var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bigtitle"},[_c('div',{staticClass:"bigtitle-inner inner"},[(_vm.item.titletype === 1 || !_vm.item.titletype)?_c('h1',[_vm._v(_vm._s(_vm.item.title))]):_vm._e(),(_vm.item.titletype === 2)?_c('h2',[_vm._v(_vm._s(_vm.item.title))]):_vm._e(),(_vm.item.titletype === 3)?_c('h3',[_vm._v(_vm._s(_vm.item.title))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }